import { defineMessages } from 'react-intl';

export default defineMessages({
  createTile: {
    id: 'cboard.components.Board.TileEditor.createTile',
    defaultMessage: 'Create tile'
  },
  editTile: {
    id: 'cboard.components.Board.TileEditor.editTile',
    defaultMessage: 'Edit Tile'
  },
  label: {
    id: 'cboard.components.Board.TileEditor.label',
    defaultMessage: 'Label'
  },
  boardName: {
    id: 'cboard.components.Board.TileEditor.boardName',
    defaultMessage: 'Board Name'
  },
  vocalization: {
    id: 'cboard.components.Board.TileEditor.vocalization',
    defaultMessage: 'Vocalization'
  },
  voiceRecorder: {
    id: 'cboard.components.Board.TileEditor.voiceRecorder',
    defaultMessage: 'Voice Recorder'
  },
  board: {
    id: 'cboard.components.Board.TileEditor.board',
    defaultMessage: 'Empty Board'
  },
  button: {
    id: 'cboard.components.Board.TileEditor.button',
    defaultMessage: 'Button'
  },
  folder: {
    id: 'cboard.components.Board.TileEditor.folder',
    defaultMessage: 'Folder'
  },
  type: {
    id: 'cboard.components.Board.TileEditor.type',
    defaultMessage: 'Type'
  },
  back: {
    id: 'cboard.components.Board.TileEditor.back',
    defaultMessage: 'Back'
  },
  next: {
    id: 'cboard.components.Board.TileEditor.next',
    defaultMessage: 'Next'
  },
  symbolSearch: {
    id: 'cboard.components.Board.TileEditor.symbolSearch',
    defaultMessage: 'Symbol search'
  },
  existingBoards: {
    id: 'cboard.components.Board.TileEditor.existingBoards',
    defaultMessage: 'Link to an existing board'
  },
  none: {
    id: 'cboard.components.Board.TileEditor.none',
    defaultMessage: 'None'
  },
  symbols: {
    id: 'cboard.components.Board.TileEditor.symbols',
    defaultMessage: 'Symbols'
  },
  editImage: {
    id: 'cboard.components.Board.TileEditor.editImage',
    defaultMessage: 'Edit image'
  }
});
